export const FIDELITY_STAGES = {
  INITIAL: 'initial',
  SUCCESS: 'success',
  ERROR: 'error',
}

export const FIDELITY_STAGES_ALLOW_BACK_BUTTON = [FIDELITY_STAGES.INITIAL]

export const FIDELITY_STAGES_ALLOW_CLOSE_BUTTON = [FIDELITY_STAGES.ERROR]

export const FIDELITY_STAGES_TITLE = {
  [FIDELITY_STAGES.INITIAL]: 'Oferta Especial',
  [FIDELITY_STAGES.SUCCESS]: 'Oferta Especial',
  [FIDELITY_STAGES.ERROR]: '',
}
